"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableConditionalStyle = void 0;
var TableConditionalStyle = (function () {
    function TableConditionalStyle(tableProperties, tableRowProperties, tableCellProperties, maskedParagraphProperties, maskedCharacterProperties, tabs) {
        this.tableProperties = tableProperties;
        this.tableRowProperties = tableRowProperties;
        this.tableCellProperties = tableCellProperties;
        this.maskedParagraphProperties = maskedParagraphProperties;
        this.maskedCharacterProperties = maskedCharacterProperties;
        this.tabs = tabs;
    }
    TableConditionalStyle.prototype.clone = function () {
        var _a;
        return new TableConditionalStyle(this.tableProperties, this.tableRowProperties, this.tableCellProperties, this.maskedParagraphProperties, this.maskedCharacterProperties, (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.clone());
    };
    return TableConditionalStyle;
}());
exports.TableConditionalStyle = TableConditionalStyle;
